import { render, staticRenderFns } from "./AuthorizationDocumentManagementList.vue?vue&type=template&id=604ed4ac&"
import script from "./AuthorizationDocumentManagementList.vue?vue&type=script&lang=js&"
export * from "./AuthorizationDocumentManagementList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports